import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import CustomGraphy from '@/components/CustomGraphy'
import CustomView from '@/components/CustomView'
import CustomButton from '@/components/CustomButton'
import DualList from '@/components/DualList'
import FormInput from '@/components/FormInput'
import yup from '@/utils/yup'
import { useAction } from '@/hooks/useAction'
import { useTableData } from '@/hooks/useTableData'
import { useFormik } from 'formik'
import { useProfile } from '@/hooks/useProfile'
import { useLoading } from '@/hooks/useLoading'

export function newProfileSchema() {
  return yup.object().shape({
    name: yup.string().required('campo obrigatório')
  })
}
interface DetailsViewProps {
  returnToTable: () => void
}

interface PermissionsInterface {
  nome: string
  permissoes: any[]
  idRole?: string
}

function DetailView({ returnToTable }: DetailsViewProps) {
  const [permissions, setPermissions] = useState<any[]>([])
  const { ROW_DATA } = useTableData()
  const { ACTION_NAME, SET_ACTION_NAME } = useAction()
  const { GET_PROFILE, CREATE_PROFILE, UPDATE_PROFILE } = useProfile()
  const { SET_LOADING } = useLoading()

  const schema = newProfileSchema()
  const { values, handleSubmit, handleChange, errors, touched } = useFormik({
    initialValues: {
      name: ''
    },
    enableReinitialize: true,
    validationSchema: !ACTION_NAME ? schema : '',
    onSubmit: (values) => {
      submit(values)
    }
  })

  useEffect(() => {
    getProfileData()
  }, [ROW_DATA])

  async function getProfileData() {
    if (!ROW_DATA) return null
    try {
      SET_LOADING(true)
    } finally {
      SET_LOADING(false)
    }
  }

  async function submit(values: any) {
    const regex = /([a-zA-Z]+)_(.+)/
    const permissoes: { tipo: string; valores: string[] }[] = []

    for (const item of permissions) {
      const tipo = item.match(regex)?.[1]
      const valor: string = item.match(regex)?.[2]

      if (tipo && valor) {
        const objIndex = permissoes.findIndex((obj) => obj.tipo === tipo)
        if (objIndex === -1) {
          permissoes.push({ tipo, valores: [valor] })
        } else {
          permissoes[objIndex].valores.push(valor)
        }
      } else {
        console.error(`O item "${item}" não corresponde ao formato esperado.`)
      }
    }

    if (!permissoes || permissoes?.length === 0)
      return toast.warning('Selecione ao menos uma permissão vinculada ao Perfil.')

    const params : PermissionsInterface[] = [
      {
        nome: ACTION_NAME === 'Editar' ? ROW_DATA?.name : values.name,
        permissoes
      }
    ]

    try {
      SET_LOADING(true)
      if (ACTION_NAME === 'Editar') {
        params[0]['idRole'] = ROW_DATA?.id ?? ''
        await UPDATE_PROFILE(params)
      } else {
        await CREATE_PROFILE(params)
      }
      GET_PROFILE()
    } finally {
      handleCleanClose()
      SET_LOADING(false)
    }
  }

  function handleCleanClose() {
    returnToTable()
    SET_ACTION_NAME('')
  }


  return (
    <CustomView
      backColor="white"
      justifyContent="flex-start"
      p="32px"
      gap={2}
      alignItems="start"
    >
      <CustomView borderBottom="1px solid #8F8E914D">
        <CustomGraphy fontSize="18px" mb="16px">
          {ACTION_NAME ? `Dados do perfil - ${ROW_DATA?.name}` : 'Novo Perfil'}
        </CustomGraphy>
      </CustomView>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        {!ACTION_NAME && (
          <CustomView style={{ maxWidth: 300 }}>
            <FormInput
              id="name"
              name="name"
              labelName="Nome"
              pr={{ md: '6px' }}
              mb="16px"
              value={values.name}
              onChange={handleChange}
              mask="WithoutMask"
              errorMessage={touched.name ? errors?.name : ''}
              customStyle="withBorder"
            />
          </CustomView>
        )}
        <DualList
          disabled={ACTION_NAME === 'Visualizar'}
          handleSelectedPermissions={(list) => setPermissions(list)}
          profilePermissions={
            ACTION_NAME ? ROW_DATA?.hiddenpermissionRoles : []
          }
        />
        <CustomView
          flexDirection="row"
          justifyContent="flex-end"
          gap={8}
          mt="32px"
        >
          <CustomButton variable="default" onClick={handleCleanClose}>
            Voltar
          </CustomButton>
          {ACTION_NAME !== 'Visualizar' && (
            <CustomButton variable="bordered" type="submit">
              Salvar Perfil
            </CustomButton>
          )}
        </CustomView>
      </form>
    </CustomView>
  )
}

export default DetailView
